// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inherit;
  border: var(--ids-swappable-active-border);
  height: 100%;
  overflow: auto;
}

:host([active]) {
  border-color: var(--ids-swappable-color-border-active);
}

::slotted(ids-search-field) {
  margin: 0 8px;
  margin-bottom: 8px;
  width: calc(100% - 16px);
  position: sticky;
  top: 0;
}

:host([searchable]) .has-searchfield {
  border-block-end: var(--ids-swaplist-border);
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--ids-card-color-background);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-swappable/ids-swappable.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,0CAAA;EACA,YAAA;EACA,cAAA;AACF;;AAEA;EACE,sDAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,MAAA;AACF;;AAGE;EACE,4CAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,kDAAA;AAAJ","sourcesContent":[":host {\n  display: inherit;\n  border: var(--ids-swappable-active-border);\n  height: 100%;\n  overflow: auto;\n}\n\n:host([active]) {\n  border-color: var(--ids-swappable-color-border-active);\n}\n\n::slotted(ids-search-field) {\n  margin: 0 8px;\n  margin-bottom: 8px;\n  width: calc(100% - 16px);\n  position: sticky;\n  top: 0;\n}\n\n:host([searchable]) {\n  .has-searchfield {\n    border-block-end: var(--ids-swaplist-border);\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: var(--ids-card-color-background);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
